module.exports = __webpack_public_path__ + "static/media/fair.ad46e0f3.svg";